import {
  IsEnum,
  IsString,
  IsBoolean,
  IsOptional,
  MaxLength,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { Type } from 'class-transformer'
import { ConsentKind } from '../enums'

/**
 * DTO pour accorder ou refuser un consentement
 */
export class GrantConsentDto {
  @ApiProperty({ enum: ConsentKind, description: 'Type de consentement' })
  @IsEnum(ConsentKind)
  kind!: ConsentKind

  @ApiProperty({
    description: 'Version du consentement',
    maxLength: 32,
    example: '1.0.0',
  })
  @IsString()
  @MaxLength(32)
  version!: string

  @ApiProperty({ description: 'Consentement accordé', default: true })
  @IsBoolean()
  isGranted!: boolean

  @ApiPropertyOptional({ description: 'Adresse IP', maxLength: 64 })
  @IsOptional()
  @IsString()
  @MaxLength(64)
  ipAddress?: string

  @ApiPropertyOptional({ description: 'User-Agent', maxLength: 512 })
  @IsOptional()
  @IsString()
  @MaxLength(512)
  userAgent?: string

  @ApiPropertyOptional({
    description: 'Locale au moment de la signature',
    maxLength: 16,
  })
  @IsOptional()
  @IsString()
  @MaxLength(16)
  localeAtSign?: string
}

/**
 * DTO pour lister les consentements
 */
export class ListConsentsDto {
  @ApiPropertyOptional({
    enum: ConsentKind,
    description: 'Filtrer par type de consentement',
  })
  @IsOptional()
  @IsEnum(ConsentKind)
  kind?: ConsentKind

  @ApiPropertyOptional({ description: "Filtrer par statut d'accord" })
  @IsOptional()
  @Type(() => Boolean)
  @IsBoolean()
  isGranted?: boolean
}
